export default {"src":"/_next/static/media/icon-intelligence.d8912cab.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};